export enum ProductState {
  READY = "READY",
  AGGREGATED = "AGGREGATED",
  SHIPPED = "SHIPPED",
  DESTROYED = "DESTROYED"
}
